import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {GruppeMedlemListeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MedlemListevisningKompaktKomponent} from "../medlem-listevisning-kompakt/medlem-listevisning-kompakt";

const debug = initDebugger('MedlemmerListevisningKompaktKomponent');

/**
 * Kompakt grid-basert listevisning av medlemmer
 */
@Component({
    selector: 'medlemmer-listevisning-kompakt',
    templateUrl: 'medlemmer-listevisning-kompakt.html',
    styleUrl: 'medlemmer-listevisning-kompakt.scss',
    imports: [
        MedlemListevisningKompaktKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemmerListevisningKompaktKomponent {
    medlemmer = input.required<GruppeMedlemListeModell[]>();
}

